import React from 'react';
import './styles/CheckboxGroup.scss';

const CheckboxGroup = ({
  name,
  label,
  options,
  value,
  onChange,
  disabled,
  error,
  touched,
  required = true,
  className,
}) => {
  return (
    <div className="form-field-container">
      <div className="input-section-container">
        {label && (
          <div className="form-label-container">
            <h5 htmlFor={name} className="form-label">
              {label}
              {required && <span style={{ color: 'red' }}> *</span>}
            </h5>{' '}
          </div>
        )}

        <div className="col-container">
          <div className={className || 'col-md-12'}>
            <div className="checkboxed-group-container">
              {options.map((option) => (
                <div key={option.value} className="input-group mb-3">
                  <div className="input-group-text">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      id={`${name}-${option.value}`}
                      name={name}
                      value={option.value}
                      checked={value === option.value}
                      onChange={(e) => {
                        if (e.target.checked) {
                          const selectedOption = options.find(
                            (opt) => String(opt.value) === e.target.value
                          );

                          if (selectedOption !== undefined) {
                            onChange(selectedOption.value); // Pass the original value
                          }
                        }
                      }}
                      disabled={disabled}
                    />
                  </div>
                  <span className="input-group-text">{option.label}</span>
                </div>
              ))}
            </div>
          </div>
          {error && touched && <div className="error">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default CheckboxGroup;
